/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit BankAccount/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import PaymentProviderMethod from 'DesignSystem/PaymentProvider/PaymentProviderMethod/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function BankAccount({
  children,
  viewPath = "/App/Account/EmbeddableCoreMessageListener/PaymentsCreatePaymentPlanForExistingInvoice/Content/Content/PaymentSources/SelectedOption/Autopay/SelectedOption/BankAccount"
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let receivableOrganizationIdValueData = fromData.useDataValue({ viewPath,
context: 'receivable',
path: 'organization._id',
})
let receivablePaymentAccountPersonPaymentAccountPayerPersonValueData = fromData.useDataValue({ viewPath,
context: 'receivable',
path: 'payment_account.person_payment_account.payer_person',
})
  return (<React.Fragment
>
<div
  data-testid="BankAccount.Vertical"
  data-view-path={viewPath}
 style={{'--mt-1-WAk87': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Vertical}`}
>
<PaymentProviderMethod
  viewPath={`${viewPath}/PaymentProviderMethod`}
 method="ach"
 data="receivable.organization._id"
 locationId={receivableOrganizationIdValueData}
 data="receivable.payment_account.person_payment_account.payer_person"
 person={receivablePaymentAccountPersonPaymentAccountPayerPersonValueData}
/>
</div>
{children}
</React.Fragment>)
}